import _implicitStylesheets from "./app.css";

import _implicitScopedStylesheets from "./app.scoped.css?scoped=true";

import _myGlobalHeader from "my/globalHeader";
import _myConfigMigration from "my/configMigration";
import _myAutoConfigurator from "my/autoConfigurator";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, t: api_text, b: api_bind} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    classMap: {
      "appHeader": true
    },
    key: 0
  }, [api_element("div", {
    classMap: {
      "logo": true
    },
    key: 1
  }, [api_custom_element("my-global-header", _myGlobalHeader, {
    key: 2
  }, [])])]), api_element("div", {
    classMap: {
      "center": true
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "container": true
    },
    key: 4
  }, []), api_element("div", {
    classMap: {
      "slds-context-bar": true
    },
    key: 5
  }, [api_element("div", {
    classMap: {
      "slds-context-bar__primary": true
    },
    key: 6
  }, [api_element("div", {
    classMap: {
      "slds-context-bar__item": true,
      "slds-context-bar__dropdown-trigger": true,
      "slds-dropdown-trigger": true,
      "slds-dropdown-trigger_click": true,
      "slds-no-hover": true
    },
    key: 7
  }, [api_element("span", {
    classMap: {
      "slds-context-bar__label-action": true,
      "slds-context-bar__app-name": true
    },
    key: 8
  }, [api_element("span", {
    classMap: {
      "slds-truncate": true
    },
    attrs: {
      "title": "App Name"
    },
    key: 9
  }, [api_text("Asset 360 Tooling")])])])]), api_element("nav", {
    classMap: {
      "slds-context-bar__secondary": true
    },
    attrs: {
      "role": "navigation"
    },
    key: 10
  }, [api_element("ul", {
    classMap: {
      "slds-grid": true
    },
    key: 11
  }, [api_element("li", {
    classMap: {
      "slds-context-bar__item": true,
      "slds-is-active": true
    },
    attrs: {
      "data-my-id": "configMigrationLi"
    },
    key: 12,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.enableConfigMigration))
    }
  }, [api_element("a", {
    classMap: {
      "slds-context-bar__label-action": true
    },
    attrs: {
      "href": "javascript:void(0);",
      "title": "Migration"
    },
    key: 13
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 14
  }, [api_text("Current Page:")]), api_element("span", {
    classMap: {
      "slds-truncate": true
    },
    attrs: {
      "title": "Home"
    },
    key: 15
  }, [api_text("Configuration Migration")])])]), api_element("li", {
    classMap: {
      "slds-context-bar__item": true
    },
    attrs: {
      "data-my-id": "autoConfiguratorLi"
    },
    key: 16,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.enableAutoConfigurator))
    }
  }, [api_element("a", {
    classMap: {
      "slds-context-bar__label-action": true
    },
    attrs: {
      "href": "javascript:void(0);",
      "title": "Menu Item"
    },
    key: 17
  }, [api_element("span", {
    classMap: {
      "slds-truncate": true
    },
    attrs: {
      "title": "Menu Item"
    },
    key: 18
  }, [api_text("Configurator")])])])])])])]), api_element("div", {
    attrs: {
      "data-my-id": "configMigration"
    },
    key: 19
  }, [api_custom_element("my-config-migration", _myConfigMigration, {
    key: 20
  }, [])]), api_element("div", {
    styleDecls: [["display", "none", false]],
    attrs: {
      "data-my-id": "autoConfigarator"
    },
    key: 21
  }, [api_custom_element("my-auto-configurator", _myAutoConfigurator, {
    key: 22
  }, [])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-app_app"
